import "./topLinks.css";

function TopLinks({ onOpenMenu, mostrarBlog }) {

  /*
  <a href="/ofertasdasemana">Ofertas da Semana</a>
          <a href="/food">Food</a>
          <a href="/frios">Frios</a> 
     */


          /*
          <div className="dropdown">
            <span>Carreiras</span>
            <div className="dropdown-menu">
              <a
                href="/portalcandidato"
                target="_blank"
                rel="noopener noreferrer"
              >
                Trabalhe conosco
              </a>

              <a href="/seja-um-representante">Seja um representante</a>
            </div>
          </div>
          */

          /*
           <div className="dropdown">
            <span>Conteúdo Eliandro</span>
            <div className="dropdown-menu">
              <a href="/quemsomos">Quem somos</a>
              <a href="/comocomprar">Como comprar</a>
            </div>
          </div>
          */


  return (
    <div className="top-links-wrapper">
      <div className="top-links">
        {/* ESQUERDA */}
        <div className="links-left">
          <div className="all-categories" onClick={onOpenMenu}>
            <span className="menu-icon">☰</span>
            <strong>Todas categorias</strong>
          </div>

          

          {mostrarBlog && (
          <a
                href="/blog-eliandro"
                target="_blank"
                rel="noopener noreferrer"
              >
                Blog
              </a>
          ) }
        </div>

        {/* DIREITA */}
        <div className="links-right">
          


        </div>
      </div>
    </div>
  );
}

export default TopLinks;
